.customer-lead-step-address-tab__container {
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 32px;

  padding: 24px 0 0;
}

.customer-lead-step-address-tab__container .customer-lead-step-address-tab__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.customer-lead-step-address-tab__container .customer-lead-step-address-tab__container__subrow {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

@media screen and (width <= 640px) {
  .customer-lead-step-address-tab__container {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .customer-lead-step-address-tab__container .customer-lead-step-address-tab__container__row {
    flex-flow: column nowrap;
    align-items: stretch;
  }
}
